import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddKeywordsProfile({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Add Keywords Profile'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />  
    )
}

